// Where the Library was, kept for the browser tab (sessionStorage) so returning to it - e.g. from the top
// bar's Library tab - reopens the same folder with the same sort order.
import type { SortOrder } from './model';

const FOLDER_KEY = 'xped.library.folder';
const SORT_KEY = 'xped.library.sort';

function read(key: string): string | null {
  try {
    return sessionStorage.getItem(key);
  } catch {
    return null;
  }
}

function write(key: string, value: string) {
  try {
    sessionStorage.setItem(key, value);
  } catch {
    // Storage unavailable: the Library just starts at the top level.
  }
}

/** The folder open when the user last left the Library; null for the top level. */
export const lastFolder = (): string | null => read(FOLDER_KEY) || null;
export const rememberFolder = (guid: string | null) => write(FOLDER_KEY, guid ?? '');

/** Where links to the Library go: the folder open when the user last left it. */
export function libraryHome(): string {
  const folder = lastFolder();
  return folder ? `/library?folder=${encodeURIComponent(folder)}` : '/library';
}

const sorts: SortOrder[] = ['newest', 'oldest', 'name'];
export const lastSort = (): SortOrder => {
  const saved = read(SORT_KEY) as SortOrder | null;
  return saved && sorts.includes(saved) ? saved : 'newest';
};
export const rememberSort = (sort: SortOrder) => write(SORT_KEY, sort);
